import { render, staticRenderFns } from "./OldUnionBody.vue?vue&type=template&id=78bd9cf3&scoped=true&"
import script from "./OldUnionBody.vue?vue&type=script&lang=js&"
export * from "./OldUnionBody.vue?vue&type=script&lang=js&"
import style0 from "./OldUnionBody.vue?vue&type=style&index=0&id=78bd9cf3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd9cf3",
  null
  
)

export default component.exports